export const cleanEGWText = (text) => {
  if (!text) return '';
  let result = text;
  result = result?.replace(/\u00C2/g, '');
  result = result?.replace(/\u2018/g, "'");
  result = result?.replace(/\u2019/g, "'");
  result = result?.replace(/\u201C/g, '"');
  result = result?.replace(/\u201D/g, '"');
  return result;
};

// Fix mojibake encoding: UTF-8 bytes stored/interpreted as Latin-1
// e.g. "l'Ã©pÃ©e" → "l'épée"
export const fixEncoding = (str) => {
  if (!str) return str;
  // Quick check: if no high-byte chars present, skip the decode attempt
  if (!/[\u00C0-\u00FF]/?.test(str)) return str;
  try {
    const bytes = new Uint8Array([...str].map(c => c.charCodeAt(0) & 0xFF));
    const decoded = new TextDecoder('utf-8')?.decode(bytes);
    // Only use decoded result if it looks valid (no replacement chars)
    if (!decoded?.includes('\uFFFD')) return decoded;
    return str;
  } catch {
    return str;
  }
};